import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useCustomerHomeStyles = makeStyles((theme: Theme) => createStyles({
  tabs: {
    marginBottom: theme.spacing(2),
  },
  homeCustomerContainer: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > *': {
      width: '80%',
      marginBottom: theme.spacing(2),
    },
  },
  [theme.breakpoints.down('xs')]: {
    homeCustomerContainer: {
      '& > *': {
        width: '100%',
      },
    },
  },
  [theme.breakpoints.up('lg')]: {
    homeCustomerContainer: {
      '& > *': {
        width: '70%',
      },
    },
  },
}));

export default useCustomerHomeStyles;
